export enum AnalyticEvent {
  // Авторизация и регистрация
  AGENT_AUTH_OPEN = 'agent_auth_open',
  AGENT_AUTH_SIGNUP = 'agent_auth_signup',
  AGENT_AUTH_SIGNUP_ERROR = 'agent_auth_signup_error',
  AGENT_FORGOTSIGN_OPEN = 'agent_forgotsign_open',
  AGENT_FORGOTSIGN_SUCCESS = 'agent_forgotsign_success',
  AGENT_FORGOTSIGN_ERROR = 'agent_forgotsign_error',
  AGENT_CALLSUPPORT = 'agent_callsupport',
  AGENT_REG_OPEN = 'agent_reg_open',
  AGENT_REG_ERROR = 'agent_reg_error',
  AGENT_REG_TO_STEP_OTP = 'agent_reg_tostep_OTP',
  AGENT_REG_OTP_OPEN = 'agent_reg_OTP_open',
  AGENT_REG_COMPLITED = 'agent_reg_complited',

  // Авторизация и Регистрация кандидата
  CANDIDATE_REG_OPEN = 'candidate_reg_open',
  CANDIDATE_REG_TOSTEP_PASSWORD = 'candidate_reg_tostep_password',
  CANDIDATE_REG_CONSENTDISTRIBUTE = 'candidate_reg_consentdistribute',
  CANDIDATE_REG_OFFICE = 'candidate_reg_office',
  CANDIDATE_REG_PASSWORD_CREATE = 'candidate_reg_password_create',
  CANDIDATE_REG_PASSWORD_SUCCESSINVENTE = 'candidate_reg_password_successinvente',
  CANDIDATE_REG_PASSWORD_ERRORINVENTE = 'candidate_reg_password_errorinvente',
  CANDIDATE_REG_PASSWORD_CONFIRM = 'candidate_reg_password_confirm',
  CANDIDATE_REG_PASSWORD_SUCCESS = 'candidate_reg_password_success',
  CANDIDATE_REG_PASSWORD_ERROR = 'candidate_reg_password_error',
  AGENT_LOGIN_SCREEN_OPENED = 'agent_login_screen_opened',
  AGENT_LOGIN_SUCCESS = 'agent_login_success',
  AGENT_LOGIN_ERROR = 'agent_login_error',
  AGENT_FORGOT_PASSWORD_SCREEN_OPENED = 'agent_forgot_password_screen_opened',
  AGENT_PASSWORD_RESET_SUCCESS = 'agent_password_reset_success',
  AGENT_PASSWORD_RESET_ERROR = 'agent_password_reset_error',
  AGENT_LOGIN_SUPPORT_CALL_CLICKED = 'agent_login_support_call_clicked',

  // Экран верификации
  CANDIDATE_VERIFICATION_SCREEN_OPENED = 'candidate_verification_screen_opened',
  // Нажал на один из сервисов верификации
  CANDIDATE_VERIFICATION_SERVICE_CLICKED = 'candidate_verification_service_clicked',
  // Экран личные данные после получения данных из любого сервиса верификации
  CANDIDATE_PERSONAL_DATA_SCREEN_OPENED = 'candidate_personal_data_screen_opened',
  // Нажал "продолжить" на экране личных данных
  CANDIDATE_PERSONAL_DATA_CONTINUE_CLICK = 'candidate_personal_data_continue_click',
  // Экран данные из сервиса верификации не найдены/получена ошибка
  CANDIDATE_VERIFICATION_ERROR_SCREEN_OPENED = 'candidate_verification_error_screen_opened',
  // Нажал "понятно" на экране когда не найдены/получена ошибка от сервиса верификации
  CANDIDATE_VERIFICATION_ERROR_ACK_CLICK = 'candidate_verification_error_ack_click',
  // Экран Офис
  AGENT_OFFICE_SCREEN_OPENED = 'agent_office_screen_opened',
  // Нажал "изменить адрес проживания" на экране Офис
  AGENT_OFFICE_EDIT_ADDRESS_CLICK = 'agent_office_edit_address_click',
  // Отображен баннер о невозможноси онлайн-оформления в этом филиале
  AGENT_OFFICE_ONLINE_UNAVAILABLE_BANNER = 'agent_office_online_unavailable_banner',
  // Нажал "оставить заявку" с баннера о невозможности онлайн-оформления в этом филиале
  AGENT_OFFICE_BANER_REQUEST_CLICK = 'agent_office_banner_request_click',
  // Нажал "продолжить" на экране Офис
  AGENT_OFFICE_CONTINUE_CLICK = 'agent_office_continue_click',
  // Экран реквизиты
  AGENT_REQUISITES_SCREEN_OPENED = 'agent_requisites_screen_opened',
  // Нажал "перейти к оформлению" на экране реквизиты
  AGENT_REQUISITES_FORM_SUBMIT_CLICK = 'agent_requisites_form_submit_click',
  // Экран оформление агентского договора
  AGENT_CONTRACT_SCREEN_OPENED = 'agent_contract_screen_opened',
  // Нажал изменить данные на экране оформления
  AGENT_CONTRACT_EDIT_DATA_CLICK = 'agent_contract_edit_data_click',
  // Открыл согласие на условия договора
  AGENT_CONTRACT_TERMS_OPENED = 'agent_contract_terms_opened',
  // Открыл агентский договор на продукты по безналичной оплате
  AGENT_CONTRACT_CASHLESS_OPENED = 'agent_contract_cashless_opened',
  // Открыл согласие на электронный документооборот
  AGENT_CONTRACT_EDO_OPENED = 'agent_contract_edo_opened',
  // Нажал галочку о подтверждении что не является госслужащим или муниципальным служащим
  AGENT_CONTRACT_NOT_CIVIL_SERVANT_CHECK = 'agent_contract_not_civil_servant_check',
  // Отображен баннер о невозможности онлайн-оформления для госслужащих и мунициальных служащих
  AGENT_CONTRACT_GOV_BLOCK_BANNER = 'agent_contract_gov_block_banner',
  // Нажал "оставить заявку" с баннера о невозможности онлайн-оформления для госслужащего или муниципального служащего
  AGENT_CONTRACT_GOV_BANNER_REQUEST_CLICK = 'agent_contract_gov_banner_request_click',
  // Нажал "подписать документы" на экране оформления
  AGENT_CONTRACT_SIGN_CLICK = 'agent_contract_sign_click',
  // Успешно подписал агентский договор на продукты по безналичной оплате через смс-код
  AGENT_CONTRACT_SIGN_SUCCESS = 'agent_contract_sign_success',
  // Ошибка подписания агентского договора на продукты по безналичной оплате через смс-код
  AGENT_CONTRACT_SIGN_ERROR = 'agent_contract_sign_error',
  // Нажал перейти к анкете для доступа к другим продуктам с главного экрана
  AGENT_MAIN_TO_QUESTIONNAIRE_CLICK = 'agent_main_to_questionnaire_click',
  // Экран дополнительные сведения по анкете для СБ
  AGENT_SB_INFO_SCREEN_OPENED = 'agent_sb_info_screen_opened',
  // Нажал перейти к анкете с экрана допольнительных сведений
  AGENT_SB_INFO_CONTINUE_CLICK = 'agent_sb_info_continue_click',
  // Экран образование
  AGENT_EDUCATION_SCREEN_OPENED = 'agent_education_screen_opened',
  // Нажал продолжить на экране образование
  AGENT_EDUCATION_CONTINUE_CLICK = 'agent_education_continue_click',
  // Экран опыт работы
  AGENT_EXPERIENCE_SCREEN_OPENED = 'agent_experience_screen_opened',
  // Нажал продолжить на экране опыта работы
  AGENT_EXPERIENCE_CONTINUE_CLICK = 'agent_experience_continue_click',
  // Экран дополнительно
  AGENT_ADDITIONALLY_SCREEN_OPENED = 'agent_additionally_screen_opened',
  // Нажал отправить анкету с дополнительными свдеениями
  AGENT_QUESTIONNAIRE_SUBMIT_CLICK = 'agent_questionnaire_submit_click',
  // Успешно отправлена анкета с дополнительными сведениями
  AGENT_QUESTIONNAIRE_SUBMIT_SUCCESS = 'agent_questionnaire_submit_success',
  // Ошибка отправки анкеты с дополнительными сведениями
  AGENT_QUESTIONNAIRE_SUBMIT_ERROR = 'agent_questionnaire_submit_error',
  // Отображается баннер на главном экране о заполненной анкете с дополнительными сведениями
  AGENT_MAIN_BANNER_SB_FORM_SHOWN = 'agent_main_banner_sb_form_shown',
  // Нажал перейти к подписанию с баннера по отправленной анкете на СБ
  AGENT_BANNER_SB_SIGN_CLICK = 'agent_banner_sb_sign_click',
  // Отображается заявка на главном экране агента который не прошел скоринг/скрининг о заполненной анкете с дополнительными сведениями
  AGENT_MAIN_BANNER_NO_SCORING_SB_FORM = 'agent_main_banner_no_scoring_sb_form',
  // Нажал перейти к подписанию с заявки по отправленной анкете на СБ
  AGENT_BANNER_SB_NO_SCORING_SIGN_CLICK = 'agent_banner_sb_no_scoring_sign_click',

  // Главный экран
  AGENT_NEWPRODUCT = 'agent_newproduct', // isagent = n (наличие агентского договора n = нет договора)
  AGENT_MOREDETAILS = 'agent_moredetails', // isagent = n (наличие агентского договора n = нет договора)
  AGENT_NEWAGREEMENT = 'agent_newagreement',
  AGENT_MAIN_OPEN = 'agent_main_open', // isagent = n isagent = y (наличие агентского договора n = нет договора)
  AGENT_AGREEMENT_TOSTEP_DOCS = 'agent_agreement_tostep_docs',
  AGENT_NOAGREEMENT_OPEN = 'agent_noagreement_open',
  AGENT_AGREEMENT_DOCS_OPEN = 'agent_agreement_docs_open',
  AGENT_AGREEMENT_TOSTEP_ADRESS = 'agent_agreement_tostep_adress',
  AGENT_AGREEMENT_ADRESS_OPEN = 'agent_agreement_adress_open',
  AGENT_AGREEMENT_TOSTEP_REQUISITES = 'agent_agreement_tostep_requisites',
  AGENT_AGREEMENT_REQUISITE_SOPEN = 'agent_agreement_requisites_open',
  AGENT_AGREEMENT_TOSTEP_FORMS = 'agent_agreement_tostep_forms',
  AGENT_AGREEMENT_FORMS_OPEN = 'agent_agreement_forms_open',
  AGENT_AGREEMENT_CHANGEDATA = 'agent_agreement_changedata',
  AGENT_AGREEMENT_AGREEMENT_FORM = 'agent_agreement_agreement_form',
  AGENT_AGREEMENT_TERMS_FORM = 'agent_agreement_terms_form',
  AGENT_AGREEMENT_PDN_FORM = 'agent_agreement_pdn_form',
  AGENT_AGREEMENT_TOSTEP_SIGN = 'agent_agreement_tostep_sign',
  AGENT_AGREEMENT_OTP_OPEN = 'agent_agreement_OTP_open',
  AGENT_AGREEMENT_COMPLITED = 'agent_agreement_complited',
  AGENT_AGREEMENT_GOTOMAIN = 'agent_agreement_gotomain',

  // "Мои продажи" клик на кнопку “найти” при поиске по фамилии или телефону клиента
  AGENT_SALES_SEARCH = 'agent_sales_search',
  // "Мои продажи" клик по кнопке “Фильтры“ на экране Мои продажи для открытия модального окна
  AGENT_SALES_FILTER_TAP = 'agent_sales_filter_tap',
  // "Мои продажи" клик по кнопке “Скачать“ для загрузки результатов поиска списка продаж
  AGENT_SALES_DOWNLOAD = 'agent_sales_download',
  // "Мои продажи" клик по кнопке "Применить" в модальном окне фильтров
  AGENT_SALES_FILTER_DONE = 'agent_sales_filter_done',
  // Header: клик на кнопку “Мои продажи” в модальном окне меню
  AGENT_SALES_M = 'agent_sales_m',
  // Header: клик по кнопке “Акты“ меню
  AGENT_STATEMENT_M = 'agent_statement_m',
  // Header: клик по кнопке “О продуктах “Пульс”“ в меню
  AGENT_ABOUTPRODUCTS_M = 'agent_aboutproducts_m',
  // Header: клик по кнопке "Контакты" в меню
  AGENT_CONTACTS_M = 'agent_contacts_m',
  // Header: клик по кнопке “Новости и обучение“ в меню
  AGENT_NEWS_M = 'agent_news_m',
  // Header: клик по кнопке “Стандарты ВСС“ в меню
  AGENT_STANDARDSVSS_M = 'agent_standardsvss_m',
  // Header: клик по кнопке “Заявки по ипотеке“ в меню
  AGENT_MORTAGAGEREQUEST_M = 'agent_mortgagerequest_m',
  // Header: клик по кнопке “Профиль“ в шапке
  AGENT_PROFILE_M = 'agent_profile_m',
  // Header: клик по кнопке "Выйти" в меню
  AGENT_EXIT_M = 'agent_exit_m',
  // Открыт экран "Профиль"
  AGENT_PROFILE_OPEN = 'agent_profile_open', // isagent = n (наличие агентского договора n = нет договора)
  // Нажал "Изменить" в профиле
  AGENT_TOSTEP_EDITPERSONALDATA = 'agent_tostep_editpersonaldata', // category = personal_data (категория изменения персональных данных, constacts = контакты )
  // Экран редактирования перс.данных
  AGENT_EDITPERSONALDATA_OPEN = 'agent_editpersonaldata_open',
  // Экран редактирования перс.данных (упала ошибка)
  AGENT_EDITPERSONALDATA_OPEN_ERROR = 'agent_editpersonaldata_open_error', // type - тип ошибки (где она произошла - web)
  // Нажал "Сохранить" (сохранил черновик изменения перс.данных)
  AGENT_EDITPERSONALDATA_SAVE = 'agent_editPersonalData_save', // category = personal_data (категория изменения персональных данных, constacts = контакты )
  // Нажал "Проверить и отправить" (отправка изменений перс.данных)
  AGENT_EDITPERSONALDATA_CHECK = 'agent_editPersonalData_check',
  // Нажал "Удалить черновик" (изменения перс.данных)
  AGENT_EDITPERSONALDATA_DELETEDRAFT = 'agent_editPersonalData_deleteDraft',
  // Открыл заявление на изменение перс.данных
  AGENT_EDITPERSONALDATA_PND_FORM = 'agent_editPersonalData_pdn_form',
  // Нажал "Отправить запрос" (на изменение перс.данных)
  AGENT_EDITPERSONALDATA_SEND = 'agent_editPersonalData_send',
  // Успешно отправлен запрос на изменение перс.данных
  AGENT_EDITPERSONALDATA_SUCCESS = 'agent_editPersonalData_success',
  // Ошибка отправки запроса на изменение перс.данных
  AGENT_EDITPERSONALDATA_ERROR = 'agent_editPersonalData_error',
  // События расторжения АгД
  AGENT_TERMINATE_M = 'agent_terminate_m',
  AGENT_TERMINATE_CAUSE = 'agent_terminate_cause',
  AGENT_TERMINATE_STATEMENT_OPEN = 'agent_terminate_statement_open',
  AGENT_TERMINATE_STATEMENT_CONTINUE = 'agent_terminate_statement_continue',
  AGENT_TERMINATE_OTP_OPEN = 'agent_terminate_OTP_open',
  AGENT_TERMINATE_OTP_SUCCESS = 'agent_terminate_OTP_success',
  AGENT_TERMINATE_OTP_ERROR = 'agent_terminate_OTP_error',
  // Нажал "Информация" на экране "Акты КВ"
  AGENT_ACTKV_INFO_TAP = 'agent_actkv_info_tap',
  // Есть неподписанные Акты КВ
  AGENT_ACTKV_UNSIGNED = 'agent_actkv_unsigned',
  // Нажал "Подписать" не подписанный акт КВ
  AGENT_ACTKV_SIGN_TAP = 'agent_actkv_sign_tap',
  // Клик по кнопке “Фильтры“ на экране "Акты КВ
  AGENT_ACTKV_FILTERS_TAP = 'agent_actkv_filter_tap',
  // Клик по кнопке "Применить" в модальном окне фильтров на экране "Акты КВ"
  AGENT_ACTKV_FILTERS_DONE = 'agent_actkv_filter_done',
  // Успешно подписан акт КВ
  AGENT_ACTKV_SIGN_SUCCESS = 'agent_actkv_sign_sucess',
  // Ошибка подписания акта КВ
  AGENT_ACTKV_SIGN_ERROR = 'agent_actkv_sign_error',

  // Доступ в SRG, продукт Ипотека
  AGENT_MORTGAGE_CLICKOK = 'agent_mortgage_clickok',
  AGENT_MORTGAGE_THEREACCESS = 'agent_mortgage_thereaccess',

  AGENT_WELCOME_SCREEN_OPENED = 'agent_welcome_screen_opened',
  AGENT_WELCOME_TO_SALES_CLICK = 'agent_welcome_to_sales_click',
  AGENT_WELCOME_TO_FORM_CLICK = 'agent_welcome_to_form_click',

  //Заключение АД с ВП 7 и 43
  AGENT_CONTRACT_OTHER_SCREEN_OPENED = 'agent_contract_other_screen_opened',
  AGENT_CONTRACT_RGS_OPENED = 'agent_contract_rgs_opened',
  AGENT_CONTRACT_RGS_LIFE_OPENED = 'agent_contract_rgs_life_opened',
  AGENT_CONTRACT_OTHER_SIGN_CLICK = 'agent_contract_other_sign_click',
  AGENT_CONTRACT_OTHER_SIGN_SUCCESS = 'agent_contract_other_sign_success',
  AGENT_CONTRACT_OTHER_SIGN_ERROR = 'agent_contract_other_sign_error',

  AGENT_MAIN_FLAGSHIP_CLICK = 'agent_main_flagship_click',
  AGENT_MAIN_MAIL_CLICK = 'agent_main_mail_click',
  AGENT_MAIN_AGENCY_PORTAL_CLICK = 'agent_main_agency_portal_click',
  AGENT_MAIN_EKIS_CLICK = 'agent_main_ekis_click',
  AGENT_MAIN_INSTRUCTION_ACCESS_OPENED = 'agent_main_instruction_access_opened',
  AGENT_MAIN_INSTRUCTION_ACCESS_CLICK_PORTAl = 'agent_main_instruction_access_click_portal',
}

export const REQUEST_ERROR_TYPE_ANALYTIC_EVENT = 'back';
